import {makeReactContext} from 'lib/makeReactContext';

/**
 * A React context for indicating whether a ReactFlow canvas is locked.
 * When locked, nodes should be disabled and interactions should be restricted.
 *
 * This context is optional - if not provided, components will not be locked.
 */
export const ReactFlowLockedContext = makeReactContext<boolean | null>(() => null, 'ReactFlowLockedContext');
